"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimPaymentSchema = exports.rejectClaimSchema = exports.acceptClaimSchema = exports.submitClaimSchema = exports.createClaimSchema = exports.rejectPreAuthSchema = exports.enhancePreAuthSchema = exports.approvePreAuthSchema = exports.requestPreAuthSchema = exports.createInsurancePricingPolicySchema = exports.ipInsuranceDecisionReasonEnum = exports.ipClaimStatusEnum = exports.ipPreAuthStatusEnum = void 0;
const zod_1 = require("zod");
/** IP insurance contracts — ADR-085 Phase 5. */
exports.ipPreAuthStatusEnum = zod_1.z.enum([
    'REQUESTED', 'SUBMITTED', 'PENDING', 'APPROVED', 'PARTIALLY_APPROVED', 'REJECTED', 'EXPIRED', 'ENHANCED', 'CLOSED',
]);
exports.ipClaimStatusEnum = zod_1.z.enum([
    'DRAFT', 'SUBMITTED', 'ACCEPTED', 'REJECTED', 'PARTIALLY_PAID', 'SETTLED',
]);
exports.ipInsuranceDecisionReasonEnum = zod_1.z.enum([
    'PREAUTH_APPROVED', 'PREAUTH_PARTIAL', 'PREAUTH_REQUIRED', 'PREAUTH_REJECTED', 'BENEFIT_EXHAUSTED',
    'SUM_INSURED_EXHAUSTED', 'POLICY_EXCLUDED', 'WAITING_PERIOD', 'COPAY_APPLIED', 'DEDUCTIBLE_APPLIED',
    'NON_NETWORK_PROVIDER', 'POLICY_INACTIVE', 'NO_ACTIVE_POLICY', 'CLAIM_REJECTED', 'REVERSAL', 'ROOM_RENT_CAP_APPLIED',
]);
/**
 * Markup is BASIS POINTS, never percent: 1250 = 12.50%.
 *
 * The cap is 10,000 (100%). Anything higher is far more likely to be percent
 * entered where basis points belong than a real contract, and a silently
 * 100x-inflated claim is not recoverable.
 */
exports.createInsurancePricingPolicySchema = zod_1.z.object({
    payerId: zod_1.z.string().uuid(),
    planId: zod_1.z.string().uuid().nullish(),
    /** Null = use whatever the patient's bed class resolves to. */
    baseTariffTier: zod_1.z.enum(['STANDARD', 'SEMI_PRIVATE', 'PRIVATE', 'DELUXE']).nullish(),
    markupBasisPoints: zod_1.z.number().int().nonnegative().max(10_000),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().nullish(),
    notes: zod_1.z.string().max(1000).optional(),
});
exports.requestPreAuthSchema = zod_1.z.object({
    patientCoverageId: zod_1.z.string().uuid(),
    payerId: zod_1.z.string().uuid(),
    planId: zod_1.z.string().uuid().optional(),
    requestedAmount: zod_1.z.number().int().positive(),
    preAuthNumber: zod_1.z.string().min(1).max(40),
    externalReference: zod_1.z.string().max(100).optional(),
});
exports.approvePreAuthSchema = zod_1.z.object({
    approvedAmount: zod_1.z.number().int().positive(),
    validUntil: zod_1.z.coerce.date().optional(),
    approvedBy: zod_1.z.string().max(150).optional(),
    reference: zod_1.z.string().max(100).optional(),
});
exports.enhancePreAuthSchema = zod_1.z.object({
    additionalAmount: zod_1.z.number().int().positive(),
    reference: zod_1.z.string().max(100).optional(),
    reason: zod_1.z.string().max(1000).optional(),
    approvedBy: zod_1.z.string().max(150).optional(),
});
exports.rejectPreAuthSchema = zod_1.z.object({ reason: zod_1.z.string().min(1).max(1000) });
exports.createClaimSchema = zod_1.z.object({
    claimNumber: zod_1.z.string().min(1).max(40),
    preAuthId: zod_1.z.string().uuid().optional(),
});
exports.submitClaimSchema = zod_1.z.object({ externalReference: zod_1.z.string().max(100).optional() });
exports.acceptClaimSchema = zod_1.z.object({ approvedAmount: zod_1.z.number().int().nonnegative() });
exports.rejectClaimSchema = zod_1.z.object({ reason: zod_1.z.string().min(1).max(1000) });
exports.claimPaymentSchema = zod_1.z.object({ paidAmount: zod_1.z.number().int().positive() });
//# sourceMappingURL=ip-insurance.schema.js.map